/**
 * Tastatur einer Radiogruppe (WAI-ARIA „Radio Group“, Ticket 1.242): Pfeil rechts/unten → nächstes Feld, links/oben →
 * voriges (jeweils rundum), Home → erstes, End → letztes. Ergebnis: Index des neuen Felds oder `null` (Taste gehört
 * nicht dazu). Reine Funktion, damit Vitest sie ohne DOM prüft.
 */
export function radioKeyTarget(key: string, index: number, count: number): number | null {
  if (count <= 0) return null;
  const current = index < 0 ? 0 : index;
  switch (key) {
    case 'ArrowRight':
    case 'ArrowDown':
      return (current + 1) % count;
    case 'ArrowLeft':
    case 'ArrowUp':
      return (current - 1 + count) % count;
    case 'Home':
      return 0;
    case 'End':
      return count - 1;
    default:
      return null;
  }
}
